import { Box, Button, Grid } from '@mui/material';
import { useApi, useMessage } from 'app/context';
import { useForm } from 'app/hooks';
import { Breadcrumb, DetailWrapperDiv, TextField } from 'app/shared';
import { buildErrorDetails, buildErrorMessage } from 'app/utils';
import { IDoctorCreate } from 'generated/axios';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const DoctorCreate = () => {
  const { doctorsApi } = useApi();
  const [loading, setLoading] = useState<boolean>(false);
  const { success, error } = useMessage();
  const navigate = useNavigate();

  const create = (form: IDoctorCreate) => {
    setLoading(true);
    doctorsApi
      .webCreateDoctor(form)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        success({ message: t('doctor.createSuccess') as string });
        navigate(-1);
      })
      .catch((err) => {
        error({ message: buildErrorMessage(err) });
        setErrors(buildErrorDetails(err));
      })
      .finally(() => setLoading(false));
  };

  const { setErrors, bindTextField, submit } = useForm<IDoctorCreate>({
    onSubmit: create,
  });

  return (
    <>
      <Breadcrumb />
      <DetailWrapperDiv>
        <Grid container spacing={4}>
          <Grid size={6}>
            <TextField label={t('doctor.lastName')} {...bindTextField({ field: 'last_name' })} />
          </Grid>
          <Grid size={6}>
            <TextField label={t('doctor.firstName')} {...bindTextField({ field: 'first_name' })} />
          </Grid>
        </Grid>
        <Box padding={4}>
          <Button sx={{ margin: 1 }} variant="contained" loading={loading} onClick={submit}>
            {t('actions.create')}
          </Button>
        </Box>
      </DetailWrapperDiv>
    </>
  );
};
